import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// REGISTRAR QR//
export const guardarRegistroQR = async (body) => {
    const result = await PrivateInterceptor(`Marcaje/guardarRegistroQR`, 'POST',body);
    return result;
}

// getRegistrosQR
export const getRegistrosQR = async (body) => {
    const result = await PrivateInterceptor(`Marcaje/getRegistrosQR`, 'POST',body);
    return result;
}

export const getListQr = async () => {
    const result = await PrivateInterceptor(`Marcaje/getListQR`, 'GET');
    return result;
}

// GUARDAR QR MARCAJE
export const guardarQrMarcaje = async (data, data1, data2) => {
    const respuesta = await PrivateInterceptor('Marcaje/guardarQrMarcaje', 'POST', {Datos: data, DetallePersonal: data1, DetalleSeccion: data2});
    return respuesta;
}

// EDITAR QR MARCAJE
export const editarQrMarcaje = async (data, data1, data2) => {
    const respuesta = await PrivateInterceptor('Marcaje/editarQrMarcaje', 'POST', {Datos: data, DetallePersonal: data1, DetalleSeccion: data2});
    return respuesta;
}